import React from 'react';
import { Card, Form, Input, Button, Switch, Select, message, Divider } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { API_BASE_URL } from '../../api/config';
import '../User/UserList.css';

const Settings: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log('保存设置:', values);
    message.success('设置保存成功！');
  };

  return (
    <div className="user-list-container">
      <h1 className="page-title">系统设置</h1>

      <Card title="基本设置" bordered={false} style={{ marginBottom: 16 }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            siteName: '声屿管理后台',
            apiUrl: API_BASE_URL,
            pageSize: 10,
            enableRegister: true,
            enableComment: true,
          }}
        >
          <Form.Item
            label="网站名称"
            name="siteName"
            rules={[{ required: true, message: '请输入网站名称' }]}
          >
            <Input placeholder="请输入网站名称" />
          </Form.Item>

          <Form.Item
            label="API 地址"
            name="apiUrl"
            rules={[{ required: true, message: '请输入API地址' }]}
          >
            <Input placeholder={API_BASE_URL} />
          </Form.Item>

          <Form.Item label="每页显示条数" name="pageSize">
            <Select>
              <Select.Option value={10}>10 条</Select.Option>
              <Select.Option value={20}>20 条</Select.Option>
              <Select.Option value={50}>50 条</Select.Option>
              <Select.Option value={100}>100 条</Select.Option>
            </Select>
          </Form.Item>

          <Divider />

          <Form.Item label="允许用户注册" name="enableRegister" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item label="允许评论" name="enableComment" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              保存设置
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="关于系统" bordered={false}>
        <p>
          <strong>系统名称：</strong>声屿后台管理系统
        </p>
        <p>
          <strong>版本号：</strong>v1.0.0
        </p>
        <p>
          <strong>技术栈：</strong>React 18 + TypeScript + Ant Design 5
        </p>
        <p>
          <strong>后端 API：</strong>FastAPI (Python)
        </p>
      </Card>
    </div>
  );
};

export default Settings;
